export enum ExperienceLevel {
  NEGATIVE,
  POSITIVE
}
